<div class="form-container" *ngFor="let form of dynamicForms">
    <cm-dynamic-form
        class="dynamic-form"
        [isZeroValueAllowed]="true"
        [elements]="form.fields"
        [disabled]="previewMode"
        [formId]="form.dynamicFormInstanceId"
        #dynamicFormComponent
        [showErrors]="showErrors"
        [sections]="sections"
    ></cm-dynamic-form>
    <button
        *ngIf="!previewMode"
        class="btn btn-default btn-action remove-btn"
        (click)="removeForm(form.dynamicFormInstanceId)"
    >
        <i class="fa fa-trash"></i> Remove form
    </button>
</div>
<button class="btn btn-default btn-action" *ngIf="!previewMode" (click)="addForm()">+ Add additional form</button>
<div
    [style.visibility]="showErrors ? 'visible' : 'hidden'"
    class="error-message"
    *ngFor="let errorText of dynamicFormErrors"
>
    {{ errorText }}
</div>
